import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { InvoiceWsDao } from "../../../core/dao/ws/invoice.ws.dao";
import { InvoiceLineWsDao } from "../../../core/dao/ws/invoiceLine.ws.dao";
import { LocationWsDao } from "../../../core/dao/ws/location.ws.dao";
import { MovementWsDao } from "../../../core/dao/ws/movement.ws.dao";
import { OrderWsDao } from "../../../core/dao/ws/order.ws.dao";
import { PipesModule } from "../../../gyzmo-commons/helpers/pipes/pipes.module";
import { DeliveryCardSkeletonModule } from "../../components/delivery-card-skeleton/delivery-card-skeleton.module";
import { DeliveryCardModule } from "../../components/delivery-card/delivery-card.module";
import { OperationDailyCountModule } from "../../components/operation-daily-count/operation-daily-count.module";
import { TitleBarModule } from "../../components/title-bar/title-bar.module";
import { DeliveryListPage } from "./delivery-list.page";

@NgModule(
    {
        declarations: [
            DeliveryListPage,
        ],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            PipesModule,
            TranslateModule,
            RouterModule.forChild([
                {
                    path: "",
                    component: DeliveryListPage,
                },
            ]),
            TitleBarModule,
            OperationDailyCountModule,
            DeliveryCardModule,
            DeliveryCardSkeletonModule,
        ],
        exports: [
            DeliveryListPage,
        ],
        providers: [
            LocationWsDao,
            MovementWsDao,
            InvoiceWsDao,
            InvoiceLineWsDao,
            OrderWsDao,
        ],
    })

export class DeliveryPageModule {
}
